import { programTypeLabel } from '@/pages/Admin/PointsAudit/programTypeLabel';
import { RewardsProgramType } from '@shared/enums';
import { TFunction } from 'i18next';

/** Pass null for Current Total Outstanding. */
export const periodLabel = (
  period: {
    endDate?: string | null,
    programType?: RewardsProgramType | null,
    startDate?: string | null,
  } | null,
  t: TFunction,
): string => (
  period
    ? t($ => $.pointsMetrics.periodLabel, {
      endDate: period.endDate,
      programType: programTypeLabel(period.programType ?? RewardsProgramType.Agronomy, t),
      startDate: period.startDate,
    })
    : t($ => $.pointsMetrics.filters.currentTotalOutstanding)
);
